module.exports = __webpack_public_path__ + "assets/img/facebook.3d5f5be3.svg";